import React, { ReactNode, createContext, useContext, useState } from 'react';
interface LoaderContextProps {
  isLoading: boolean;
  isCartLoading: boolean;
  isBodyLoading: boolean;
  showLoader: () => void;
  hideLoader: () => void;
  showCartLoader: () => void;
  hideCartLoader: () => void;
  showBodyLoader: () => void;
  hideBodyLoader: () => void;
}

const LoaderContext = createContext<LoaderContextProps>({
  isLoading: false,
  isCartLoading: false,
  isBodyLoading: false,
  showLoader: () => { },
  hideLoader: () => { },
  showBodyLoader: () => { },
  hideBodyLoader: () => { },
  showCartLoader: () => { },
  hideCartLoader: () => { },
});

export const LoaderProvider = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCartLoading, setIsCartLoading] = useState(false);
  const [isBodyLoading, setIsBodyLoading] = useState(false);

  const showCartLoader = () => {
    setIsCartLoading(true);
  };

  const hideCartLoader = () => {
    setIsCartLoading(false);
  };
  const showBodyLoader = () => {
    setIsBodyLoading(true);
  };

  const hideBodyLoader = () => {
    setIsBodyLoading(false);
  };
  const showLoader = () => {
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
  };
  return (
    <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader, isCartLoading, showCartLoader, hideCartLoader, isBodyLoading, showBodyLoader, hideBodyLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};
const useLoader = () => {
  return useContext(LoaderContext);
};
export default useLoader;